module.exports = __webpack_public_path__ + "static/media/LK_Location Pin.27b37c88.svg";